import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import { vuetify } from './plugins/vuetify';
import { router } from './plugins/router';
import { pinia } from './plugins/pinia';
import { VueQueryPlugin, vueQueryOptions } from './plugins/vue-query';
import { setupI18n } from './i18n';

async function bootstrap() {
  const app = createApp(App);

  const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (sentryDsn) {
    Sentry.init({
      app,
      dsn: sentryDsn,
      environment: import.meta.env.MODE,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
      ],
      tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  app.use(pinia);
  app.use(VueQueryPlugin, vueQueryOptions);

  const { i18next, I18NextVue } = await setupI18n();
  app.use(I18NextVue, { i18next });

  const clerkPk = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;
  if (clerkPk) {
    const { clerkPlugin } = await import('@clerk/vue');
    app.use(clerkPlugin, { publishableKey: clerkPk });
  }

  app.use(vuetify);
  app.use(router);

  app.mount('#app');
}

bootstrap().catch((err) => {
  console.error('Failed to bootstrap app', err);
});
